<template>
  <v-container fill-height fluid>
    <v-layout justify-center align-center>
      <v-flex column lg8 align-self-center>
        <material-card
          icon="mdi-book-open"
          color="indigo"
          :title="$t('Pages.RecordBooks.update')"
          :text="$t('Common.enter_details')">
          <v-card-text>
            <record-book-form edit @save="update" :recordBook="recordBook"></record-book-form>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import RecordBookForm from './Form'
  export default {
    components: {RecordBookForm},
    data: () => ({
        recordBook: {},
    }),
    computed: {

    },
    created () {
      this.getRecordBook(this.$route.params.id);
    },
    methods: {
      getRecordBook(id){
        this.setFetching(true);
        this.repositories.recordBook.get(id, 'partner,importTransportType,exportTransportType,recordBookFiles,recordBookType,documentType,realLocation,user').then(response => {
          this.recordBook = response.data.data;
          this.recordBook.partner_id = this.recordBook.partner.id;
          this.recordBook.record_book_type_id = this.recordBook.recordBookType.id;
          this.recordBook.document_type_id = this.recordBook.documentType.id;
          this.recordBook.real_location_id = this.recordBook.realLocation.id;
          this.recordBook.import_transport_type_id = this.recordBook.importTransportType.id;
          this.recordBook.export_transport_type_id = this.recordBook.exportTransportType.id;
          this.recordBook.files = [];
          if (this.recordBook.recordBookFiles && this.recordBook.recordBookFiles.length > 0) {
            this.recordBook.recordBookFiles.forEach(file => {
              let type = 'image';
              if(file.url.split('.')[1] === 'pdf') {
                type = 'application/pdf'
              }
              if(file.url.split('.')[1] === 'doc') {
                type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              }
              this.recordBook.files.push({
                ...file,
                name: file.url,
                type: type
              });
            });
          }
        }).finally(() => {
            this.setFetching(false);
        });
      },
      update(data){
        const files = [];

        for(let i = 0; i < this.recordBook.files.length; i++) {
          let finded = false;
          for(let j = 0; j < data.files.length; j++) {
            if(this.recordBook.files[i].id === data.files[j].id) {
              finded = true;
            }
          }
          if(!finded) {
            files.push(this.recordBook.files[i]);
          }
        };

        data.files.forEach(file => {
          if(!file.id) {
            files.push(file);
          }
        });

        this.repositories.recordBook.update(this.recordBook.id, data).then((response) => {
          this.$toast.info(response.data.message);
          if(files.length > 0) {
            this.uploadFiles(response.data.data.id, files);
          }
        });
      },
      uploadFiles(recordBookId, files){
        files.forEach(file => {
          if (!file.id) {
            const data = new FormData();
            data.append("record_book_id", recordBookId);
            data.append("url", file);
            this.repositories.recordBook.uploadFile(data);
          } else {
            this.repositories.recordBook.removeFile(file.id);
          }
        });
      }
    }
  }
</script>

<style lang="scss">

</style>
